import { Component, EventEmitter, Input, Output } from '@angular/core';

// INTERFACES
import { OptionInterface } from '../../../shared/interfaces/common.interface';

@Component({
  selector: 'lum-filter-tag',
  templateUrl: './filter-tag.component.html',
  styleUrls: ['./filter-tag.component.scss'],
})
export class FilterTagComponent {
  @Input()
  queryId :string = 'tag';

  @Input()
  value :number[] = [];

  @Input()
  label :string = 'Tag';

  @Input()
  placeholder :string = '';

  @Input()
  inlineChips :boolean = false;

  @Output()
  onFilterSelect :EventEmitter<any[] | any> = new EventEmitter<any>();

  onSelectedChangeEvent(tags :any) :void {
    this.onFilterSelect.emit({
      [this.queryId]: tags.map((tag :OptionInterface) => tag.value),
    });
  }
}
